function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var getStyles = function getStyles(prefixCls, token) {
  return _defineProperty({}, ".".concat(prefixCls), {
    // height: 64,
    flexShrink: 0,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0px -1px 2px 0px rgba(0, 0, 0, 0.10)',
    backgroundColor: 'rgba(255, 255, 255, 0.618)',
    backdropFilter: 'blur(10px)',
    '.scroll': {
      flex: 1,
      overflow: 'auto'
    },
    '.stickyBar': {
      position: 'sticky',
      top: 0,
      display: 'flex',
      padding: '12px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '4px',
      overflow: 'hidden',
      backgroundColor: '#f8f8f8',
      '.content': {
        color: '#6e707a',
        fontSize: '12px'
      }
    },
    '.formContainer': {
      padding: 20
    },
    '.formView': {},
    '.footer': {
      flexShrink: 0,
      padding: '12px 24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      boxShadow: '0px -1px 2px 0px rgba(0, 0, 0, 0.10)',
      backgroundColor: 'rgba(255, 255, 255, 0.618)',
      backdropFilter: 'blur(10px)',
      '.actions': {
        display: 'flex',
        alignItems: 'center',
        gap: 14
      }
    }
  });
};